// app/javascript/controllers/flash_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        // Optional: Auto-dismiss after a set time period
        // setTimeout(() => this.dismiss(), 5000)
    }

    dismiss() {
        this.element.classList.add("opacity-0", "transition-opacity", "duration-300")
        setTimeout(() => {
            this.element.remove()
        }, 300)
    }
}